<div class="card card-container" [ngClass]="cardClass" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseExit()">
    <div class="card-body">
        <div class="more-icons">
            <i class="fa fa-times" [hidden]="!showComplete || !isHover" (click)="completeTimer()" title="Complete Timer"></i>
        </div>
        <div class="timer-card-title-info" (click)="click()" [title]="titleTooltip" [hidden]="!titleTooltip">
            {{titleDisplay}}  <i class="fa fa-tasks-alt  dw-blue" title="View Job in Trust" (click)="openWindow(this.trustJobUrl, $event)"></i>
        </div>
        <div class="timer-card-title-info" (click)="click()" [title]="titleTooltip" [hidden]="titleTooltip">
            {{titleDisplay}} <i class="fa fa-tasks-alt  dw-blue" title="View Job in Trust" (click)="openWindow(this.trustJobUrl, $event)"></i>
        </div>
        <div class="timer-card-date-info" (click)="click()">
            <span>
             {{dateDisplay}}
            </span>
        </div>
        <div class="timer" (click)="click()">
            {{ timeLeftDisplay }}
        </div>
        <div class="dw-button-bar-basic" [hidden]="!isHover || buttonVisibility?.hideButtons">
            <button class="btn btn-success mr-1" (click)="start()" [hidden]="!buttonVisibility?.showStart">Start</button>
            <button class="btn btn-danger  mr-1" (click)="stop()" [hidden]="!buttonVisibility?.showStop">Stop</button>
            <button class="btn btn-warning" (click)="reset()" [hidden]="!buttonVisibility?.showReset">Reset</button>
        </div>
    </div>
</div>